import type { ReactNode } from 'react';

import type { ResolvedCollectionMediaLayout } from '@/lib/blocks/collection/media-layout';
import { getImageSizeClassName } from '@/lib/blocks/image-size';
import { cn } from '@/lib/utils';

const MEDIA_ALIGN_CLASSNAMES: Record<ResolvedCollectionMediaLayout['align'], string> = {
  start: 'mr-auto',
  center: 'mx-auto',
  end: 'ml-auto',
};

export function CollectionMediaFrame({
  layout,
  className,
  children,
}: {
  layout: ResolvedCollectionMediaLayout;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'min-w-0 w-full',
        getImageSizeClassName(layout.size),
        MEDIA_ALIGN_CLASSNAMES[layout.align],
        className,
      )}
    >
      {children}
    </div>
  );
}
